import {Injectable} from '@angular/core';
import {HttpService} from '../../shared/services/http.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseResponse} from '../../shared/models/respose/BaseResponse';
import {Classification} from '../../shared/models/Classification';
import {Order} from '../../shared/models/Order';
import {PaginatedDataResponse} from '../../shared/models/respose/PaginatedDataResponse';
import {PaginatedDataRequest} from '../../shared/models/request/PaginatedDataRequest';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClassificationService extends HttpService {



  getAll(): Observable<BaseResponse<Classification[]>>{
    return this.get('classifications/index');
  }

  getPaginatedList(entries: number,
                   page: number,
                   data?: Classification,
                   order?: Order): Observable<BaseResponse<PaginatedDataResponse<Classification>>>{
    const request = new PaginatedDataRequest<Classification>(entries, page, data, order);
    return this.post('classifications', request).pipe(
      map(response => {
        return response;
      })
    );
  }

  register(request: Classification): Observable<BaseResponse<Classification>>{
    return this.post('classifications/store', request);
  }

  deleteItem(id: number): Observable<BaseResponse<Classification>>{
    return this.delete('classifications', id);
  }

  updateItem(request: Classification, id: number): Observable<BaseResponse<Classification>>{
    return this.put('classifications', request, id);
  }
}
